import { render } from "./p-text-area.vue?vue&type=template&id=774ff630&scoped=true"
import script from "./p-text-area.vue?vue&type=script&lang=js"
export * from "./p-text-area.vue?vue&type=script&lang=js"

import "./p-text-area.vue?vue&type=style&index=0&id=774ff630&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774ff630"],['__file',"src/components/p-text-area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "774ff630"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('774ff630', __exports__)) {
    api.reload('774ff630', __exports__)
  }
  
  module.hot.accept("./p-text-area.vue?vue&type=template&id=774ff630&scoped=true", () => {
    api.rerender('774ff630', render)
  })

}


export default __exports__